<template>
    <div v-redirect-if-no-permission:VIEW_PAYMENTS>
        <loading :value="loading" message="Searching"></loading>
        <v-card>
            <v-card-title>
                <h3>Pending Payments</h3>
                <v-spacer></v-spacer>
                <v-autocomplete label="Captain" :loading="captainLoading" :items="captains"   v-model="returnId"  :search-input.sync="search" reverse outline clearable item-text="full_name"
                    item-value="id" height="1px" >
                    <template slot="item" slot-scope="captains">
                        <v-list-tile-content>
                            <v-list-tile-title v-html="captains.item.full_name"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="captains.item.username"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </template>
                </v-autocomplete>
                <v-spacer></v-spacer>
                <v-label v-if="!!selected_captain && data.length > 0">Total amount to pay to captain {{ !!selected_captain ?
                    selected_captain.full_name : '' }} is : {{ totalAmount }}</v-label>
                <!-- <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        @keyup.enter="getData"
                ></v-text-field> -->
                <v-spacer></v-spacer>

                <v-btn color="primary" v-if="!!selected_captain && data.length > 0 && selected.length > 0"
                    @click="dialog = true">Mark selected payments
                    as done</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="data.length > 0" @click="exportToExcel">Export to excel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog2 = true">Financial Stats</v-btn>
            </v-card-title>
            <v-data-table :loading="loading" v-model="selected" select-all :headers="headers" :items="data"
                class="elevation-1">
                <template v-slot:headers="props">
                    <tr>
                        <th>
                            <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details
                                @click.stop="toggleAll"></v-checkbox>
                        </th>
                        <th v-for="header in props.headers" :key="header.text">
                            {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr :active="props.selected">
                        <td @click="check(props)">
                            <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.id }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.captain_name }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.captain_username }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.entity_type }}</td>
                        <td v-if="props.item.entity_type == 'Booking'" @click="activeRideId = props.item.ride_id"
                            class="text-xs-center"><a>{{ props.item.entity_id }}</a></td>
                        <td @click="check(props)" v-if="props.item.entity_type != 'Booking'" class="text-xs-center">{{
                            props.item.entity_id }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.meter_price }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.fee }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.to_pay }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.paid_money }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.payment_type }}</td>
                        <td @click="check(props)" class="text-xs-center">{{ props.item.required_to_pay }}</td>
                    </tr>
                </template>

            </v-data-table>
        </v-card>

        <v-dialog v-model="dialog" width="500px">
            <v-card v-if="!!selected_captain">
                <v-card-title><b>Mark as done</b></v-card-title>
                <v-card-text>
                    <v-text-field type="number" label="Paid amount" v-model="paid_amount"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="markAsDone">Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog2" width="500px">
            <v-card>
                <v-card-title><b>Get Financial Stats</b></v-card-title>
                <v-card-text>
                    <choose-date v-model="startDate" style="width: 100%" label="Start date" />
                    <choose-date v-model="endDate" style="width: 100%" label="End date" />
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="financialStats">Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog :value="!!activeRideId" lazy @input="activeRideId = null">
            <ride-page v-if="activeRideId" :ride_id="activeRideId" />
        </v-dialog>

    </div>
</template>

<script>
import loading from "@/components/LoadingComponent";
import ChooseUserMulti from "@/components/wasilni/input/ChooseUserMutli";
import { json2excel, excel2json } from 'js2excel';
import ChooseDate from "@/components/wasilni/input/ChooseDate";
import RidePage from "@/views/RidePage";

export default {
    name: "NewAccounting",
    title: "New Accounting",
    components: { ChooseUserMulti, loading, ChooseDate, RidePage },
    props: {
          
            initialSearchParams: {
                type: URLSearchParams,
                default: () => new URLSearchParams()
            }
        },
    data() {
        return {
            requiredRules: [
                v => v !== null && v !== undefined && v !== '' || 'This Field Is Required',
            ],
            numberRules: [
                v => !!v || 'Required field',
                v => /^[0-9]*$/.test(v) || 'invalid value'
            ],
            model: { name: '' },
            selected: [],
            headers: [
                { text: '#', value: 'id', align: 'center' },
                { text: 'Name', value: 'captain_name', align: 'center' },
                { text: 'Username', value: 'captain_username', align: 'center' },
                { text: 'Entity Type', value: 'entity_type', align: 'center' },
                { text: 'Entity Id', value: 'entity_id', align: 'center' },
                { text: 'Meter price', value: 'meter_price', align: 'center' },
                { text: 'Fee', value: 'fee', align: 'center' },
                { text: 'To pay', value: 'to_pay', align: 'center' },
                { text: 'Paid money', value: 'paid_money', align: 'center' },
                { text: 'Payment type', value: 'payment_type', align: 'center' },
                { text: 'Required to pay', value: 'required_to_pay', align: 'center' }
            ],
            data: [],
            captains: [],
            totalAmount: 0,
            search: '',
            selected_captain: null,
            loading: false,
            dialog: false,
            dialog2: false,
            valid: false,
            startDate: null,
            endDate: null,
            activeRideId: null,
            captainLoading:false,
            paid_amount: 0,
            returnId:null

        }
    },
    watch: {
        search(val) {
            this.captainLoading = true;
            const params = new URLSearchParams(this.initialSearchParams);
                params.append("search", val);
            this.axios.get(`captain`,{params})
                .then(res => {
                    this.captains = Array.isArray(res.data.data.data) ? res.data.data.data : Object.values(res.data.data.data);
                    this.captains.forEach(element => {
                        element.full_name = element.first_name + ' ' + element.last_name;
                    });
                })
                .catch(err => console.log(err.message))
                .finally(() => this.captainLoading = false);



        },
        returnId(val) {
           this.getData(val);


        }
    },
    mounted() {
        this.getData();
       // this.getCaptains();
    },
    methods: {
        activeRide() {

        },
        toggleAll() {
            if (this.selected.length) this.selected = []
            else this.selected = this.data.slice()
            this.totalAmount = this.selected.length > 0 ? this.selected.map(a => a.required_to_pay).reduce((a, b) => a + b) : 0;
        },
        check(props) {
            props.selected = !props.selected;
            this.totalAmount = this.selected.length > 0 ? this.selected.map(a => a.required_to_pay).reduce((a, b) => a + b) : 0;
        },
        getData(captain_id) {
            this.loading = true;
            this.totalAmount = 0;
            this.data = [];
            if (!!captain_id) {
                this.selected_captain = this.captains.find(c => c.id == captain_id)
            } else
                this.selected_captain = null;
            this.axios.get(`account/get_accounting_data` + (!!captain_id ? `?captain_id=` + captain_id : ''))
                .then(res => {
                    this.data = Array.isArray(res.data.data) ? res.data.data : Object.values(res.data.data);
                    this.data.forEach(element => {
                        if (element.entity_type) {
                            let tmp = element.entity_type.split("\\");
                            element.entity_type = tmp[tmp.length - 1];
                        }
                    });
                })
                .catch(err => console.log(err.message))
                .finally(() => this.loading = false);
        },
        getCaptains() {
            this.loading = true;

            this.axios.get(`captain?perPage=100`)
                .then(res => {
                    this.captains = Array.isArray(res.data.data.data) ? res.data.data.data : Object.values(res.data.data.data);
                    this.captains.forEach(element => {
                        element.full_name = element.first_name + ' ' + element.last_name;
                    });
                })
                .catch(err => console.log(err.message))
                .finally(() => this.loading = false);



        },
        financialStats() {
            if (!this.startDate || !this.endDate) {
                window.getApp.$emit("SHOW_TOAST", "Please Enter start and end dates", "red")
                return;
            }
            this.loading = true;
            this.axios.get(`get_financial`, {
                params: {
                    "start": this.startDate,
                    "end": this.endDate
                },
            })
                .then(res => {
                    this.exportFinancialStatsToExcel(res.data.data)
                    this.dialog2 = false;
                    this.startDate = null;
                    this.endDate = null;
                })
                .catch(err => console.log(err.message))
                .finally(() => this.loading = false);



        },
        markAsDone() {
            this.paid_amount = Number(this.paid_amount)
            if (this.paid_amount == 0) {
                window.getApp.$emit("SHOW_TOAST", "Please Enter the paid amount", "red")
                return;
            }
            if (this.paid_amount > 0 && !confirm("Pay " + this.paid_amount + " S.P to captain "+this.selected_captain.full_name +"?")) {
                return;
            }
            if (this.paid_amount < 0 && !confirm("Collect " +(-1* this.paid_amount )+ " S.P from captain "+this.selected_captain.full_name +"?")) {
                return;
            }
            this.loading = true;
            this.axios.post('account/mark_as_done', { ids: this.selected.map(a => a.id), paid_amount: this.paid_amount, captain_id: this.selected_captain.id })
                .then(res => {
                    this.paid_amount = 0;
                    this.getData(this.selected_captain.id);
                })
                .catch(err => console.log(err.message))
                .finally(() => { this.loading = false; this.dialog = false; });
        },
        exportToExcel() {
            try {
                let dataToPrint = [];
                this.data.forEach(element => {
                    let entry = {
                        "id": element.id,
                        "captain_name": element.captain_name,
                        "captain_username": element.captain_username,
                        "entity_type": element.entity_type,
                        "entity_id": element.entity_id,
                        "meter_price": element.meter_price,
                        "fee": element.fee,
                        "to_pay": element.to_pay,
                        "paid_money": element.paid_money,
                        "payment_type": element.payment_type,
                        "required_to_pay": element.required_to_pay
                    };
                    dataToPrint.push(entry);
                });
                let filename = !!this.selected_captain ? 'payments for ' + this.selected_captain.full_name : 'payments for all';
                json2excel({
                    data: dataToPrint,
                    name: filename,
                    formateDate: 'yyyy/mm/dd'
                });
            } catch (e) {
                console.error('export error');
            }
        },
        exportFinancialStatsToExcel(data) {

            try {
                let dataToPrint = [data];

                let filename = 'FinancialStats';
                json2excel({
                    data: dataToPrint,
                    name: filename,
                    formateDate: 'yyyy/mm/dd'
                });
            } catch (e) {
                console.error('export error');
            }
        }
    }
}
</script>

<style scoped></style>